import { Button, Drawer, Row, Space, Form } from 'antd';
import NumberInput from 'app/components/NumberInput/NumberInput';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { checkIsPositiveNumber } from 'utils/validationHelpers';

interface IProps {
  isOpen: boolean;
  isSubmitLoading: boolean;
  resourceUnit: string;
  onClose: () => void;
  onSubmit: (averagePrice: number) => void;
}

const UsedResourcePriceDrawer: FC<IProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitLoading,
  resourceUnit,
}) => {
  const { t } = useTranslation();

  const [form] = Form.useForm();

  // Clear form on close
  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  const onFinish = (values: { averagePrice: string }) => {
    const averagePrice = Number(values.averagePrice);
    onSubmit(averagePrice);
  };

  return (
    <Drawer
      title={t('UsedResource.PriceDrawer.Title', 'Change average price')}
      visible={isOpen}
      forceRender={true}
      onClose={onClose}
      destroyOnClose
      placement="right"
      width={400}
      footer={
        <Row justify="end">
          <Space>
            <Button onClick={onClose}>
              {t('UsedResource.PriceDrawer.Cancel', 'Cancel')}
            </Button>

            <Button
              loading={isSubmitLoading}
              form="companyShareForm"
              key="submit"
              htmlType="submit"
              type="primary"
            >
              {t('UsedResource.PriceDrawer.Save', 'Save')}
            </Button>
          </Space>
        </Row>
      }
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{ layout: 'vertical' }}
        requiredMark="optional"
        id="companyShareForm"
        onFinish={onFinish}
      >
        <Form.Item
          label={t('UsedResourceDetails.Table.AveragePrice', {
            defaultValue: 'Average price (€/{{resourceUnit}})',
            resourceUnit,
          })}
          name={'averagePrice'}
          rules={[{ required: true }, { validator: checkIsPositiveNumber }]}
        >
          <NumberInput
            placeholder={t('UsedResourceDetails.Table.AveragePrice', {
              defaultValue: 'Average price (€/{{resourceUnit}})',
              resourceUnit,
            })}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default UsedResourcePriceDrawer;
